import { type ViewportSize } from "shared/helpers/device-info/getScreenInfo";

/**
 * Fired on `window` when the SSO iframe's parent window changes size.
 * `useDeviceInfo({ watchScreen: true })` listens for it.
 */
export const PARENT_VIEWPORT_CHANGE_EVENT = "pillar:parent-viewport-change";

let parentViewport: ViewportSize | undefined;

/**
 * The parent window's size while embedded in the SSO iframe, as last reported
 * by `iframe.html`. Kept outside React on purpose: the wrapper posts it on
 * every scroll frame alongside the visible slice, and holding it in context
 * would re-render every subscriber while the user scrolls.
 */
export const getParentViewport = (): ViewportSize | undefined => parentViewport;

/**
 * Stores the parent window's size and fires `PARENT_VIEWPORT_CHANGE_EVENT`, but
 * only when it actually changed, so scrolling the parent never re-renders.
 */
export const setParentViewport = (next: ViewportSize): void => {
  if (
    parentViewport?.width === next.width &&
    parentViewport?.height === next.height
  ) {
    return;
  }
  parentViewport = next;
  window.dispatchEvent(new Event(PARENT_VIEWPORT_CHANGE_EVENT));
};
